var t;!function(t){t.INPUT="input",t.TEXT_AREA="textarea"}(t||(t={}));export{t as InputType};
